import { useState, useRef, useEffect } from 'react';

export default function InfoTooltip({ children }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <span ref={ref} className="relative inline-flex items-center ml-1">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-4 h-4 rounded-full bg-slate-700 hover:bg-slate-600 text-slate-300 text-[10px] font-bold flex items-center justify-center leading-none transition-colors"
        aria-label="Mais informações"
      >
        ?
      </button>

      {open && (
        <div className="absolute z-50 left-6 top-0 w-72 bg-[var(--surface-2)] border border-[var(--surface-4)] rounded-lg shadow-xl p-3 text-xs text-slate-300 space-y-2">
          {children}
        </div>
      )}
    </span>
  );
}
